var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCodeQuality = function SvgCodeQuality(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 68,
    fill: "none",
    viewBox: "0 0 68 68"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M53.28 18.363H3.967v41.138H53.28z",
    className: "code-quality_svg__white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#code-quality_svg__paint0_linear_2567_8191)",
    d: "M50.822 26.02H6.578v30.514h44.244z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M50.822 20.578H6.578v3.656h44.244z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB366",
    d: "M12.726 27.287H9.922v.903h2.804zM12.726 36.426H9.922v.903h2.804z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M21.01 28.75h-2.805v.903h2.804zM24.222 28.75h-2.804v.903h2.804zM29.895 28.75h-4.94v.903h4.94zM22.41 30.256h-2.805v.903h2.805zM25.625 30.256H22.82v.903h2.805zM22.41 33.373h-2.805v.903h2.805zM25.625 33.373H22.82v.903h2.805zM31.3 33.373h-4.94v.903h4.94zM21.01 34.943h-2.805v.904h2.804zM24.222 34.943h-2.804v.904h2.804zM23.814 31.781H21.01v.903h2.804zM27.027 31.781h-2.804v.903h2.804zM32.7 31.781h-4.94v.903h4.94z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB366",
    d: "M12.726 38.512H9.922v.903h2.804zM12.726 47.652H9.922v.904h2.804z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M21.01 39.975h-2.805v.903h2.804zM24.222 39.975h-2.804v.903h2.804zM29.895 39.975h-4.94v.903h4.94zM22.41 41.502h-2.805v.903h2.805zM25.625 41.502H22.82v.903h2.805zM22.41 44.6h-2.805v.903h2.805zM21.01 46.168h-2.805v.903h2.804zM24.222 46.168h-2.804v.903h2.804zM23.814 43.008H21.01v.903h2.804zM27.027 43.008h-2.804v.903h2.804zM32.7 43.008h-4.94v.903h4.94z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB366",
    d: "M12.726 49.76H9.922v.903h2.804z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M21.01 51.223h-2.805v.903h2.804zM24.222 51.223h-2.804v.903h2.804zM29.895 51.223h-4.94v.903h4.94zM22.41 52.727h-2.805v.903h2.805z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD795",
    d: "M14.537 28.75h-2.805v.903h2.805zM17.773 28.75H14.97v.903h2.804zM15.941 30.256h-2.804v.903h2.804zM19.174 30.256h-2.805v.903h2.805zM15.941 33.373h-2.804v.903h2.804zM19.174 33.373h-2.805v.903h2.805zM14.537 34.943h-2.805v.904h2.805zM17.773 34.943H14.97v.904h2.804zM17.341 31.781h-2.804v.903h2.804zM20.578 31.781h-2.805v.903h2.805zM14.537 39.975h-2.805v.903h2.805zM17.773 39.975H14.97v.903h2.804zM15.941 41.502h-2.804v.903h2.804zM19.174 41.502h-2.805v.903h2.805zM15.941 44.6h-2.804v.903h2.804zM19.174 44.6h-2.805v.903h2.805zM14.537 46.168h-2.805v.903h2.805zM17.773 46.168H14.97v.903h2.804zM17.341 43.008h-2.804v.903h2.804zM20.578 43.008h-2.805v.903h2.805zM14.537 51.22h-2.805v.904h2.805zM17.773 51.22H14.97v.904h2.804zM15.941 52.727h-2.804v.903h2.804zM19.174 52.727h-2.805v.903h2.805zM17.341 54.252h-2.804v.903h2.804zM20.578 54.252h-2.805v.903h2.805z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M23.814 54.252H21.01v.903h2.804zM27.027 54.252h-2.804v.903h2.804zM32.7 54.252h-4.94v.903h4.94zM38.245 43.008h-4.94v.903h4.94zM43.79 43.008h-4.94v.903h4.94z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M49.657 21.352h-2.114v2.107h2.114zM46.397 21.352h-2.114v2.107h2.114zM43.16 21.352h-2.113v2.107h2.114zM9.901 21.352H7.787v2.107h2.114z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#CECECE",
    d: "M15.738 49.137V9h48.313v40.137z",
    className: "code-quality_svg__white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#code-quality_svg__paint2_linear_2567_8191)",
    d: "M62.093 16.156H17.85v30.515h44.243z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    d: "M62.093 10.715H17.85v3.656h44.243z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB366",
    d: "M23.998 17.424h-2.805v.903h2.805zM23.998 26.563h-2.805v.903h2.805z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M32.28 18.887h-2.803v.903h2.804zM35.494 18.887H32.69v.903h2.804zM41.167 18.887h-4.94v.903h4.94zM33.681 20.393h-2.804v.903h2.804zM36.896 20.393h-2.804v.903h2.804zM33.681 23.51h-2.804v.903h2.804zM36.896 23.51h-2.804v.903h2.804zM42.57 23.51h-4.94v.903h4.94zM32.28 25.08h-2.803v.903h2.804zM35.494 25.08H32.69v.903h2.804zM35.086 21.918H32.28v.903h2.805zM38.299 21.918h-2.805v.903h2.804zM43.971 21.918h-4.94v.903h4.94z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB366",
    d: "M23.998 28.648h-2.805v.904h2.805zM23.998 37.79h-2.805v.902h2.805z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M32.28 30.111h-2.803v.904h2.804zM35.494 30.111H32.69v.904h2.804zM41.167 30.111h-4.94v.904h4.94zM33.681 31.639h-2.804v.903h2.804zM36.896 31.639h-2.804v.903h2.804zM33.681 34.736h-2.804v.904h2.804zM32.28 36.305h-2.803v.903h2.804zM35.494 36.305H32.69v.903h2.804zM35.086 33.145H32.28v.903h2.805zM38.299 33.145h-2.805v.903h2.804zM43.971 33.145h-4.94v.903h4.94z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFB366",
    d: "M23.998 39.897h-2.805v.903h2.805z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M32.28 41.357h-2.803v.904h2.804zM35.494 41.357H32.69v.904h2.804zM41.167 41.357h-4.94v.904h4.94zM33.681 42.863h-2.804v.904h2.804z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD795",
    d: "M25.808 18.887h-2.804v.903h2.804zM29.045 18.887H26.24v.903h2.805zM27.213 20.393h-2.805v.903h2.804zM30.445 20.393H27.64v.903h2.804zM27.213 23.51h-2.805v.903h2.804zM30.445 23.51H27.64v.903h2.804zM25.808 25.08h-2.804v.903h2.804zM29.045 25.08H26.24v.903h2.805zM28.613 21.918h-2.804v.903h2.804zM31.85 21.918h-2.805v.903h2.804zM25.808 30.111h-2.804v.904h2.804zM29.045 30.111H26.24v.904h2.805zM27.213 31.639h-2.805v.903h2.804zM30.445 31.639H27.64v.903h2.804zM27.213 34.736h-2.805v.904h2.804zM30.445 34.736H27.64v.904h2.804zM25.808 36.305h-2.804v.903h2.804zM29.045 36.305H26.24v.903h2.805zM28.613 33.145h-2.804v.903h2.804zM31.85 33.145h-2.805v.903h2.804zM25.808 41.357h-2.804v.904h2.804zM29.045 41.357H26.24v.904h2.805zM27.213 42.863h-2.805v.904h2.804zM30.445 42.863H27.64v.904h2.804zM28.613 44.389h-2.804v.903h2.804zM31.85 44.389h-2.805v.903h2.804z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9FAFB",
    d: "M35.086 44.389H32.28v.903h2.805zM38.299 44.389h-2.805v.903h2.804zM43.971 44.389h-4.94v.903h4.94zM49.516 33.145h-4.94v.903h4.94zM55.061 33.145h-4.94v.903h4.94z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M60.929 11.488h-2.114v2.108h2.114zM57.669 11.488h-2.114v2.108h2.114zM54.432 11.488h-2.114v2.108h2.114zM21.173 11.488h-2.114v2.108h2.114z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "code-quality_svg__paint0_linear_2567_8191",
    x1: 28.624,
    x2: 28.623,
    y1: 19.774,
    y2: 100.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "code-quality_svg__paint2_linear_2567_8191",
    x1: 39.896,
    x2: 39.895,
    y1: 9.91,
    y2: 79.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C3144"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
};
export default SvgCodeQuality;